import { MessageSquare, Sparkles, Star } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateTicketSentimentAnalysisAr: TemplateAr = {
  name: 'أتمتة تحليل مشاعر التذاكر بالذكاء الاصطناعي',
  description:
    'اكتشف مشاعر العميل لحظياً، وأشّر على العملاء المنزعجين، ووجّه الحالات العاجلة لموظف بشري فوراً.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'رسالة' },
    { icon: Sparkles, label: 'الـ AI يحلل' },
    { icon: Star, label: 'درجة المشاعر', final: true },
  ],
  detailDescription: {
    paragraph1:
      'اعرف وش يحس به عميلك وهو يتكلم، مو بعد ما يترك تقييماً سيئاً. الـ AI يحلل النبرة وأنماط اللغة ومؤشرات الانفعال في كل رسالة وإيميل ومحادثة، ويحدد العملاء المنزعجين أو الغاضبين أو المعرّضين للخسارة. والدرجة تتحدّث باستمرار طوال المحادثة، فتقدر تتدخل قبل ما تتفاقم المشكلة.',
    paragraph2:
      'بيانات المشاعر توصل لوين تحتاجها — تنبيه Slack لمّا ترتفع المشاعر السلبية، أو تحديث لوحة المتابعة للفريق، أو تصدير لمستودع البيانات لتحليل الاتجاهات. والـ AI يشغّل مسار التصعيد أول ما تتجاوز المشاعر الحد الحرج. وأنماط المشاعر تغذّي برامج التدريب وتحسين الجودة عندك.',
  },
  benefits: [
    'الـ AI يكتشف العميل المنزعج فوراً',
    'يمنع التصعيد قبل ما يصير',
    'محادثات العملاء المعرّضين للخسارة تاخذ الأولوية',
    'تتبّع اتجاهات المشاعر على فريقك كله',
    'يرفع رضا عملائك استباقياً',
    'تعرف فرص التدريب من بيانات المشاعر',
  ],
};
